import { render, staticRenderFns } from "./HeadingImageSection.vue?vue&type=template&id=e9f4c96a&scoped=true&"
import script from "./HeadingImageSection.vue?vue&type=script&lang=js&"
export * from "./HeadingImageSection.vue?vue&type=script&lang=js&"
import style0 from "./HeadingImageSection.vue?vue&type=style&index=0&id=e9f4c96a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f4c96a",
  null
  
)

export default component.exports